import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import styles from './LeadsBoard.module.css';

const leadsLabel = (count) => (count === 1 ? '1 lead' : `${count} leads`);

function StageColumn({ stage, leads, renderCard }) {
  const { Icon, label, tone, emptyText } = stage;
  return (
    <section className={`${styles.column} ${styles[tone]}`} aria-label={`${label}: ${leadsLabel(leads.length)}`}>
      <header className={styles.columnHeader}>
        <span className={styles.columnIcon}><Icon style={{ fontSize: 18 }} /></span>
        <h3 className={styles.columnTitle}>{label}</h3>
        <span className={styles.columnCount}>{leads.length}</span>
      </header>
      <div className={styles.columnBody}>
        {leads.length > 0 ? leads.map(renderCard) : (
          <div className={styles.columnEmpty}>
            <span className={styles.columnEmptyIcon}><Icon style={{ fontSize: 18 }} /></span>
            {emptyText}
          </div>
        )}
      </div>
    </section>
  );
}

function SkeletonColumn() {
  return (
    <section className={`${styles.column} ${styles.gray}`} aria-hidden="true">
      <header className={styles.columnHeader}>
        <Skeleton variant="rounded" width={30} height={30} sx={{ borderRadius: '9px' }} />
        <Skeleton variant="text" width="50%" />
      </header>
      <div className={styles.columnBody}>
        {[0, 1].map((i) => (
          <Skeleton key={i} variant="rounded" height={128} sx={{ borderRadius: '14px', bgcolor: '#EEF1F8' }} />
        ))}
      </div>
    </section>
  );
}

/**
 * Kanban do funil: uma coluna por etapa, rolagem horizontal quando a
 * largura não cabe (notebook com menu aberto e celular).
 * `columns`: [{ stage, leads }]; `renderCard(lead)` desenha cada card.
 */
function LeadsBoard({ columns, loading, renderCard, skeletonCount = 4 }) {
  return (
    <div className={styles.scroller}>
      <div className={styles.board} style={{ '--columns': loading ? skeletonCount : columns.length }}>
        {loading
          ? Array.from({ length: skeletonCount }, (_, i) => <SkeletonColumn key={i} />)
          : columns.map(({ stage, leads }) => (
            <StageColumn key={stage.key} stage={stage} leads={leads} renderCard={renderCard} />
          ))}
      </div>
    </div>
  );
}

export default LeadsBoard;
